import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import { AdminLayout } from "./components/admin/AdminLayout";
import Dashboard from "./pages/admin/Dashboard";
import ContentList from "./pages/admin/ContentList";
import ContentForm from "./pages/admin/ContentForm";
import UsersPage from "./pages/admin/Users";
import PlansPage from "./pages/admin/Plans";
import SettingsPage from "./pages/admin/Settings";
import NotificationsPage from "./pages/admin/Notifications";
import MetricsPage from "./pages/admin/Metrics";
import ProfilePage from "./pages/admin/Profile";
import HomeSectionsPage from "./pages/admin/HomeSections";
import LoginPage from "./pages/auth/Login";
import ForgotPasswordPage from "./pages/auth/ForgotPassword";
import ResetPasswordPage from "./pages/auth/ResetPassword";
import LegalPage, { LegalIndexPage } from "./pages/legal/LegalPage";
import DocsPage from "./pages/docs/DocsPage";
import { AuthProvider } from "./contexts/AuthContext";
import { RequireAuth } from "./components/auth/RequireAuth";
import { Sentry } from "./lib/sentry";

const queryClient = new QueryClient();

const FallbackUI = () => (
  <div style={{ padding: 32, textAlign: "center", fontFamily: "system-ui" }}>
    <h1>Algo salio mal</h1>
    <p>El error fue reportado. Recarga la pagina para intentar de nuevo.</p>
    <button onClick={() => window.location.reload()} style={{ padding: "8px 16px", marginTop: 16 }}>
      Recargar
    </button>
  </div>
);

const App = () => (
  <Sentry.ErrorBoundary fallback={<FallbackUI />}>
  <AuthProvider>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/auth/login" element={<LoginPage />} />
            <Route path="/legal" element={<LegalIndexPage />} />
            <Route path="/legal/:type" element={<LegalPage />} />
            <Route path="/docs" element={<DocsPage />} />
            <Route path="/auth/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/auth/reset-password" element={<ResetPasswordPage />} />
            <Route
              path="/admin"
              element={
                <RequireAuth>
                  <AdminLayout />
                </RequireAuth>
              }
            >
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="profile" element={<ProfilePage />} />
              <Route path="content" element={<ContentList />} />
              <Route path="content/new" element={<ContentForm />} />
              <Route path="content/:id" element={<ContentForm />} />
              <Route path="metrics" element={<MetricsPage />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="notifications" element={<NotificationsPage />} />
              <Route path="plans" element={<PlansPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="home" element={<HomeSectionsPage />} />
            </Route>
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </AuthProvider>
  </Sentry.ErrorBoundary>
);

export default App;
